/**
 * Tools & Resources — "All" pill for the category buttons row.
 */
(function () {
	const wrapper = document.querySelector('.tools-resources .category-filter');
	if (!wrapper) {
		return;
	}

	const BUTTON = 'search-filter-input-button';
	const SELECTED = BUTTON + '--is-selected';
	const ALL_CLASS = 'tools-resources-all';

	function getSelectedCategories(group) {
		return Array.prototype.filter.call(
			group.querySelectorAll('.' + SELECTED),
			function (button) {
				return !button.classList.contains(ALL_CLASS);
			}
		);
	}

	let clearing = false;

	// Deselect one category at a time: S&F updates (and can re-render the buttons)
	// after each click, so clicking them all at once only clears the first one.
	function clearCategories() {
		if (clearing) {
			return;
		}
		clearing = true;

		let attempts = 0;

		function clearNext() {
			const group = wrapper.querySelector('.search-filter-input-button-group');
			const selected = group ? getSelectedCategories(group) : [];

			if (!selected.length || attempts >= 20) {
				clearing = false;
				return;
			}

			attempts++;
			const button = selected[0];
			button.click();
			waitUntilCleared(button, clearNext);
		}

		clearNext();
	}

	// Wait until the clicked button is deselected or replaced (max ~3s).
	function waitUntilCleared(button, callback) {
		let checks = 0;

		(function check() {
			if (!button.isConnected || !button.classList.contains(SELECTED) || checks >= 30) {
				setTimeout(callback, 50);
				return;
			}
			checks++;
			setTimeout(check, 100);
		})();
	}

	function sync() {
		const group = wrapper.querySelector('.search-filter-input-button-group');
		if (!group) {
			return;
		}

		let all = group.querySelector('.' + ALL_CLASS);
		if (!all) {
			all = document.createElement('button');
			all.type = 'button';
			all.className = BUTTON + ' ' + ALL_CLASS;
			all.textContent = 'All';
			all.addEventListener('click', function (event) {
				event.preventDefault();
				// Only clears the categories — search, topics and sort stay as they are.
				clearCategories();
			});
			group.insertBefore(all, group.firstChild);
		}

		const isAll = getSelectedCategories(group).length === 0;
		if (all.classList.contains(SELECTED) !== isAll) {
			all.classList.toggle(SELECTED, isAll);
			all.setAttribute('aria-pressed', isAll ? 'true' : 'false');
		}
	}

	// S&F re-renders/toggles the buttons after each selection and results update.
	new MutationObserver(sync).observe(wrapper, {
		childList: true,
		subtree: true,
		attributes: true,
		attributeFilter: ['class'],
	});

	sync();
})();
